
// 插件路由
const hotel = () => import(/* webpackChunkName: "hotel" */ '~/addon/hotel/pages/hotel.vue')

const routes = [
	{
        path: '/hotel',
        component: hotel
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/hotel/router/index.js